export const initialState = {
    invoices: [],
    theme: { isLightTheme: true }
};